import { Component, Inject, OnInit } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { RichTextEditorComponent } from '../../shared/rich-textEditor/rich-textEditor.component'; // Import FormsModule
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatIconModule } from '@angular/material/icon';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';

@Component({
  selector: 'app-internal-approval',
  standalone: true,
  imports: [
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    CommonModule,
    FormsModule,
    RichTextEditorComponent,
    MatIconModule,
  ],
  templateUrl: './internal-approval.component.html',
  styleUrls: ['./internal-approval.component.css'],
})
export class InternalApprovalComponent implements OnInit {
  pending: string = 'pending';
  constructor(
    private dialogRef: MatDialogRef<InternalApprovalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private tenderingService: TenderingService,
    private requestForQuotationService: RequestForQuotationService,
    public dialog: MatDialog
  ) {}

  form: FormGroup;
  resetRichTextEditor = false;
  selectedUsers: any[] = [];
  usersToView: any[] = [];
  userList: any;
  approvalResponses: any;
  modalType: string;
  searchQuery: string = '';
  filterUserList = []; // Initialize with all users

  ngOnInit(): void {
    this.form = new FormGroup({
      approver_note: new FormControl('', Validators.required),
    });

    this.userList = this.data?.users;
    this.filterUserList = [...this.userList];
    this.approvalResponses = this.data?.approvalResponses;
    this.modalType = this.data?.modalType;

    console.log(this.modalType);
    console.log('response', this.approvalResponses);
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  addUser(event: any) {
    const selectedUserId = +event.value;

    const selectUser = this.userList.find((user) => user.id === selectedUserId);
    console.log('The event value is:', selectUser);
    if (selectUser) {
      const exists = this.selectedUsers.some(
        (selected) => selected.id === selectUser.id
      );
      if (!exists) {
        this.selectedUsers.push(selectUser?.id);
        this.usersToView.push(selectUser);
      }
    }
  }

  approverNote(content: string) {
    this.form.controls['approver_note'].setValue(content);
  }

  prepareDataToSubmit() {
    const data = {
      notes: this.form.value.approver_note,
      users: this.selectedUsers,
    };

    return data;
  }

  sendApproval() {
    const dataToSubmit = this.prepareDataToSubmit();

    if (this.modalType === 'itt') {
      this.tenderingService
        .sendIttForApproval(
          dataToSubmit,
          this.data?.projectId,
          this.modalType,
          this.data?.ResponseId
        )
        .subscribe({
          next: (response: any) => {
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
          },
          error: (error: any) => {
            console.error('Login failed:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    } else if (this.modalType === 'rfq') {
      this.requestForQuotationService
        .sendRfqForApproval(
          dataToSubmit,
          this.data?.projectId,
          this.modalType,
          this.data?.ResponseId
        )
        .subscribe({
          next: (response: any) => {
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
          },
          error: (error: any) => {
            console.error('Login failed:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    } else {
      this.projectsService
        .sendApprovalRequest(
          this.data?.projectId,
          this.data?.ResponseId,
          dataToSubmit,
          this.modalType
        )
        .subscribe({
          next: (response: any) => {
            this.toast.success(response.meta.message, 'SUCCESS', 4000);
            this.closeApproval();
          },
          error: (error: any) => {
            console.error('Login failed:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    }
  }

  closeApproval() {
    this.selectedUsers = [];
    this.dialogRef.close('closeApproval'); // Close the dialog and pass the result
  }
  removeUser(user: any) {
    this.selectedUsers = this.selectedUsers.filter(
      (selected) => selected !== user.id
    );
    this.usersToView = this.usersToView.filter(
      (selected) => selected.id !== user.id
    );
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  // Function to filter users based on the search query

  filterUsers() {
    if (this.searchQuery) {
      this.userList = this.filterUserList.filter((user) =>
        user.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.userList = [...this.filterUserList];
    }
  }
}
